import NavbarComp from "@/components/elements/navbar";
import { useMemo } from "react";
import { global } from "utils/pageConstants";

const Layout = ({
  children,
  pageContext,
  blank,
  application,
  customerCareHeader,
}) => {
  const { navbar, notificationBanner } = useMemo(() => global().attributes, []);

  return (
    <div className="flex flex-col justify-between min-h-screen text-onmoPrimaryBlack">
      {/* Aligned to the top */}
      <div className={`${customerCareHeader ? "bg-onmoLightGrey" : ""}`}>
        <NavbarComp
          navbar={navbar}
          pageContext={pageContext}
          notificationBanner={notificationBanner}
          blank={blank}
          application={application}
          customerCareHeader={customerCareHeader}
          showNav
        />
        <div className={`${application ? "mt-[66px]" : ""}`}>
          <div className="flex flex-col">{children}</div>
        </div>
      </div>
      {/* Aligned to the bottom */}
    </div>
  );
};

export default Layout;
